// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2DTPV","sendOtp":"AuthorizeToLogin_sendOtp__1ZXRH"};